import React from 'react';
import { connect } from 'react-redux';
import {
  FormGroup,
  Label,
  Input,
} from 'reactstrap';

class AddUserInput extends React.PureComponent {
  componentDidMount() {
    const { id, editing } = this.props;
    if (!editing) {
      this.handleChange({ target: { id } });
    }
  }

  validate = (value) => {
    const { pattern } = this.props;
    const matches = value.match(pattern) || [];
    return matches.length > 0;
  };

  handleChange = ({ target }) => {
    const { dispatch, value: defaultValue } = this.props;
    const { id, value = defaultValue } = target;

    const valid = this.validate(value || '');

    dispatch({
      type: 'EDIT_ADD_AGENCY',
      id,
      value,
      valid,
    });
  };

  render() {
    const {
      values,
      value,
      id,
      validations,
      label,
    } = this.props;
    const valid = validations[id];

    return (
      <FormGroup>
        <Label for={id} className="font-weight-bold">
          {label}
        </Label>
        <Input
          id={id}
          name={id}
          className="border"
          value={value || values[id] || ''}
          invalid={!valid}
          onChange={this.handleChange}
        />
      </FormGroup>
    );
  }
}

const mapStateToProps = (store) => ({
  values: store.addagency.values,
  validations: store.addagency.validations,
  editing: store.addagency.editing,
});

export default connect(mapStateToProps)(AddUserInput);
